export enum Salutation {
    MR = 'MR',
    MRS = 'MRS',
}
